// Translation: Russian > Status
const status = Object.freeze({
	loadingData: '',
	updatingData: ''
})

// Export
export default status
